module.exports = __webpack_public_path__ + "static/media/frameshop_3.70964903.jpg";